
// Change this to the strapi url on launch
export const strapiUrl = 'https://dcstudiobackend-production.up.railway.app';